module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/fs-left-bg.708bef4d.svg";